import React from 'react';
import AppPage from './AppPage';

function PendingView({ state }) {
  return (
    <AppPage>
      <h1 className="signup-title">Hang tight — almost there</h1>
      <p className="signup-sub">
        {state?.business || 'Your brand'}&apos;s signup is being
        reviewed.
      </p>
      <p className="text-sm text-up-clr-dark-grey leading-relaxed">
        Your pricing needs a quick review by our team. This page checks back
        automatically, and we&apos;ll also email you as soon as your signup is
        ready to continue.
      </p>
    </AppPage>
  );
}

export default PendingView;
